<div class="chat-modal-content-image" *ngIf='show' (click)="close()">
    <img class="chat-modal-window-content-image" [src]='response' (click)="close()">
</div>
  